import wetvKernel from '@tencent/wetv-kernel';
import { qua, getAppid, beforeRequest } from '../util/util';
const { fetcher } = wetvKernel;
const { configInstace } = wetvKernel;
const {
  vipDomain,
} = configInstace;
const { videoAppid } = getAppid();

export default {
  paidCode: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      `https://${vipDomain}/${global.base.paidCode}`,
      body,
      {
        CSRF: true,
        originReturn: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  ProcessTVPreAuth: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      `https://${vipDomain}/${global.base.ProcessTVPreAuth}`,
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  CreateGuidIntl: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      `https://${vipDomain}/${global.base.CreateGuidIntl}`,
      body,
      {
        CSRF: true,
        originReturn: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  GetMsgIntl: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      `https://${vipDomain}/${global.base.GetMsgIntl}`,
      body,
      {
        CSRF: true,
        originReturn: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
};
